import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  changeSettingValue,
  deletePublicHoliday,
  getPublicHoliday,
  savePublicHoliday,
} from "../../../../../Redux/actions";
import {
  changeDateFormat,
  checkArray,
  checkNull,
} from "../../../../../helpers";
import moment from "moment";
import ModelContainer from "../../../../Components/ModelContainer";
import ErrorContainer from "../../../../Components/ErrorContainer";

const publicHolidaySchema = yup.object({
  id: yup.string().nullable(),
  date: yup.string().required(),
  annual_recurrence: yup.string().required(),
  open_for_business: yup.string().required(),
  inlieu_leave_eligible: yup.string().required(),
});

const Holidays = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPublicHoliday());

    return () => {
      dispatch(changeSettingValue("public_holiday_details", null));
    };
  }, []);

  const {
    public_holiday_details,
    publicHolidayModal,
    is_public_holiday_loading,
  } = useSelector((state) => state.settingReducer);

  /* PublicHolidays */
  const initialpublicHolidayForm = {
    id: "",
    date: "",
    annual_recurrence: "",
    open_for_business: "",
    inlieu_leave_eligible: "",
  };
  const {
    register: publicHolidayReg,
    formState: { errors: publicHolidayErrors },
    handleSubmit: publicHolidaySubmit,
    setValue: publicHolidaySetValue,
    reset: publicHolidayReset,
  } = useForm({
    resolver: yupResolver(publicHolidaySchema),
    defaultValues: initialpublicHolidayForm,
    mode: "all",
    reValidateMode: "onChange",
  });
  const [publicHolidayInputForm, setPublicHolidayInputForm] = useState(
    initialpublicHolidayForm
  );
  const changePublicHolidayInputHandler = (input, val) => {
    publicHolidaySetValue(input, val);
    setPublicHolidayInputForm((prevState) => ({ ...prevState, [input]: val }));
  };
  const initialPublicHolidayModalState = (
    initailVal = initialpublicHolidayForm
  ) => {
    setPublicHolidayInputForm(initailVal);
    publicHolidayReset(initailVal);
  };
  const closePublicHolidayModal = useCallback(
    (value) => {
      dispatch(changeSettingValue("publicHolidayModal", value));
      initialPublicHolidayModalState();
    },
    [publicHolidayModal]
  );
  const submitPublicHolidayForm = (data) => {
    data.byPass = "0"; //static
    data.date = moment(data?.date).format("yyyy-MM-DD");
    console.log("submitPublicHolidayForm", data);
    dispatch(savePublicHoliday(data));
  };
  const deletePublicHolidayHandler = (id) => {
    dispatch(deletePublicHoliday({ id }));
  };

  const getPublicHolidayAction = (publicHoliday) => {
    let res = (
      <a
        href="#_"
        class="deleteSp circle_icon"
        onClick={() => deletePublicHolidayHandler(publicHoliday?.id)}
      >
        <i class="iconSprites delete-icon"></i>
      </a>
    );
    return res;
  };

  return (
    <div
      className="tab-pane fade show active"
      id="nav-contact"
      role="tabpanel"
      aria-labelledby="nav-contact-tab"
    >
      <div className="row mx-0">
        <div className="container px-0">
          <div className="accordion" id="accordionPanelsStayOpenExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseOne"
                  aria-expanded="true"
                  aria-controls="panelsStayOpen-collapseOne"
                >
                  <div className="col d-flex align-items-center">
                    <h4 className="event-alert p-0 mb-0">Public Holidays</h4>
                  </div>{" "}
                </button>
              </h2>
              <div
                id="panelsStayOpen-collapseOne"
                className="accordion-collapse collapse show"
                aria-labelledby="panelsStayOpen-headingOne"
              >
                <div className="">
                  <div className="row mx-0">
                    <div className="container px-0">
                      <div className="shadowclass mt-0">
                        <div className="table-responsive">
                          <table className="checklist-table remove-space inventory_table">
                            <thead>
                              <tr>
                                <th className="second-th header" width="">
                                  <a href="#_" className="">
                                    {" "}
                                    Holiday Name{" "}
                                  </a>
                                </th>
                                <th className="header">
                                  <a href="#_" className="">
                                    Date
                                  </a>
                                </th>
                                <th className="header">Annual Recurrence</th>
                                <th className="header">Open For Business</th>
                                <th className="header">
                                  In-Lieu Leave Eligible?
                                </th>
                                <th className="action-td"> Action </th>
                              </tr>
                            </thead>
                            <tbody>
                              {checkArray(
                                public_holiday_details?.storeHolidays
                              ) &&
                                public_holiday_details?.storeHolidays.map(
                                  (holiday) => {
                                    return (
                                      <tr>
                                        <td>{holiday?.holiday_name} </td>
                                        <td>
                                          {holiday?.annual_recurrence == 1
                                            ? changeDateFormat(
                                                holiday?.date,
                                                "MMM D"
                                              )
                                            : changeDateFormat(
                                                holiday?.date,
                                                "MMM D, yyyy"
                                              )}
                                        </td>
                                        <td>
                                          {holiday?.annual_recurrence == 1
                                            ? "Yes"
                                            : "No"}
                                        </td>
                                        <td>
                                          {holiday?.open_for_business == 1
                                            ? "Yes"
                                            : "No"}
                                        </td>
                                        <td>
                                          {holiday?.inlieu_leave_eligible}
                                        </td>
                                        <td>
                                          <div className="d-flex justify-content-center">
                                            {getPublicHolidayAction(holiday)}
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                            </tbody>
                          </table>
                        </div>
                          <div className="my-3">
                            <button
                              className="btn green-btn-revert add-plus addSp"
                              id="addCount"
                              type="button"
                              onClick={() => closePublicHolidayModal(true)}
                            >
                              <i className="i-icon"> </i> Add Public Holidays
                            </button>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModelContainer
        title={`Add Store Holidays / Dates Closed`}
        open={publicHolidayModal}
        closeModal={closePublicHolidayModal}
        submitModal={publicHolidaySubmit(submitPublicHolidayForm)}
        is_loading={is_public_holiday_loading}
      >
        <form
          class=""
          id="StoreHolidayAddShForm"
          method="post"
          accept-charset="utf-8"
        >
          <fieldset class="">
            {console.log("publicHolidayErrors", publicHolidayErrors)}
            <input
              type="hidden"
              name="data[StoreHoliday][byPass]"
              value="0"
              id="byPass"
            />{" "}
            <ul class="form-list label-group new-form">
              <li>
                <label for="StoreHolidayHolidayName" class="required">
                  Holiday Name
                </label>{" "}
                <div class="input-wrap">
                  <input
                    {...publicHolidayReg("holiday_name")}
                    value={publicHolidayInputForm?.holiday_name}
                    onChange={(e) =>
                      changePublicHolidayInputHandler(
                        "holiday_name",
                        e?.target?.value ?? ""
                      )
                    }
                    class="required"
                    placeholder="Holiday Name"
                    maxlength="50"
                    type="text"
                    id="StoreHolidayHolidayName"
                  />{" "}
                  <ErrorContainer
                    errors={publicHolidayErrors}
                    name="holiday_name"
                  />
                </div>
              </li>
              <li>
                <label for="StoreHolidayStartTime" class="required">
                  Date
                </label>{" "}
                <DatePicker
                  {...publicHolidayReg("date")}
                  autoComplete="new-password"
                  dateFormat="yyyy-MM-dd"
                  value={publicHolidayInputForm?.date}
                  onChange={(val) =>
                    changePublicHolidayInputHandler("date", val)
                  }
                  selected={publicHolidayInputForm?.date}
                />
                <ErrorContainer errors={publicHolidayErrors} name="date" />
              </li>
              <li>
                <label for="StoreHolidayAnnualRecurrence" class="required">
                  Annual Recurrence
                </label>{" "}
                <div class="input-wrap select-div">
                  <select
                    {...publicHolidayReg("annual_recurrence")}
                    value={publicHolidayInputForm?.annual_recurrence}
                    onChange={(e) =>
                      changePublicHolidayInputHandler(
                        "annual_recurrence",
                        e?.target?.value ?? ""
                      )
                    }
                    id="StoreHolidayAnnualRecurrence"
                  >
                    <option value="">Select</option>
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                  </select>{" "}
                  <ErrorContainer
                    errors={publicHolidayErrors}
                    name="annual_recurrence"
                  />
                </div>
              </li>
              <li>
                <label for="StoreHolidayOpenForBusiness" class="required">
                  Open For Business
                </label>{" "}
                <div class="input-wrap select-div">
                  <select
                    {...publicHolidayReg("open_for_business")}
                    value={publicHolidayInputForm?.open_for_business}
                    onChange={(e) =>
                      changePublicHolidayInputHandler(
                        "open_for_business",
                        e?.target?.value ?? ""
                      )
                    }
                    class="open_business"
                    id="StoreHolidayOpenForBusiness"
                  >
                    <option value="">Select</option>
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                  </select>{" "}
                  <ErrorContainer
                    errors={publicHolidayErrors}
                    name="open_for_business"
                  />
                </div>
              </li>
              <li class="leave_eligible" style={{ display: "block" }}>
                <label for="StoreHolidayInlieuLeaveEligible" class="required">
                  In-Lieu Leave Eligible?
                </label>{" "}
                <div class="input-wrap select-div">
                  <select
                    {...publicHolidayReg("inlieu_leave_eligible")}
                    value={publicHolidayInputForm?.inlieu_leave_eligible}
                    onChange={(e) =>
                      changePublicHolidayInputHandler(
                        "inlieu_leave_eligible",
                        e?.target?.value ?? ""
                      )
                    }
                    class="required"
                    id="StoreHolidayInlieuLeaveEligible"
                  >
                    <option value="">Select</option>
                    <option value="Given">Given</option>
                    <option value="No">No</option>
                  </select>{" "}
                  <ErrorContainer
                    errors={publicHolidayErrors}
                    name="inlieu_leave_eligible"
                  />
                </div>
              </li>
            </ul>
          </fieldset>
        </form>
      </ModelContainer>
    </div>
  );
};
export default Holidays;
